import api from './api';
import type { Booking } from '../types';

export const bookingService = {
  getBookings: async (params?: { status?: string; websiteId?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.status) searchParams.append('status', params.status);
    if (params?.websiteId) searchParams.append('websiteId', params.websiteId);
    const response = await api.get(`/api/bookings?${searchParams.toString()}`);
    return response.data.data as { bookings: Booking[]; total: number };
  },

  createBooking: async (data: Partial<Booking>) => {
    const response = await api.post('/api/bookings', data);
    return response.data.data as Booking;
  },

  updateBooking: async (id: string, data: Partial<Booking>) => {
    const response = await api.patch(`/api/bookings/${id}`, data);
    return response.data.data as Booking;
  },

  cancelBooking: async (id: string) => {
    const response = await api.patch(`/api/bookings/${id}`, { status: 'cancelled' });
    return response.data.data as Booking;
  },

  deleteBooking: async (id: string) => {
    await api.delete(`/api/bookings/${id}`);
  },
};
